<template>
  <v-container class="providers">
    <v-list-item-title class="headline mb-4 title cloud-title">Cloud provider</v-list-item-title>
    <v-layout wrap class="text-left" justify-start>
        <v-flex ml-4 v-for="provider in providers" :key="provider.id" xs3 class="cloud-provider" :class="{ 'selected-provider' : provider.selected, 'cloud-provider-error' : errors[0] && !errors[1] }" @click="onSelectedProvider(provider.id, provider.name)">
            <div class="round">
              <v-img v-if="provider.name === 'az'" contain src="../../../assets/azure.svg" height="6.5vh" class="ml-4 mr-4 mb-3"></v-img>
              <v-img v-else-if="provider.name==='aws'" contain src="../../../assets/aws.svg" height="7vh"></v-img>
              <v-img v-else contain src="../../../assets/gcp.svg" height="7vh" class="ml-2"></v-img>
              <input type="checkbox" :id="provider.id" :checked="provider.selected" />
              <label :key="provider.id"></label>
            </div>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      parsedProviders: []
    };
  },
  props: ["errors", "providers"],
  methods: {
    onSelectedProvider(id, name) {
      if (this.providers.length>1) {
        this.providers.map(provider => provider.id === id ? provider.selected = !provider.selected : provider.selected = false)
        this.$emit("selectedProvider", name);
        this.$emit("selectedProviderId", id);
      }
    }
  }
};
</script>

<style scoped>
.providers {
  padding-top: 45px;
}

.cloud-provider {
  background-color: white !important;
}

.selected-provider {
  background: white !important;
  border: 2px solid #6db42c !important;
}

.round {
  position: relative;
  padding-left: 5px;
  padding-right: 5px;
}

.round label {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: -6px;
  position: absolute;
  top: -6px;
  width: 28px;
  background-color: #e2e2e2;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #6db42c;
  border-color: #6db42c;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.cloud-provider {
  height: 76px;
  border: 2px solid #eeeeee;
  border-radius: 6px;
  background: #eeeeee 0% 0% no-repeat padding-box;
  color: #6a6a6a;
}

.cloud-provider-error {
  border-color: red;
}
</style>
